/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { Form, Button } from 'reactstrap'
import { API } from "../../../config/api";
import { FaEdit, FaTimes } from 'react-icons/fa'
import Modal from 'react-bootstrap/Modal';
import { useMutation } from "react-query";
import "bulma/css/bulma.css";
import "../Styled.css"
import Swal from "sweetalert2";
import swal from "sweetalert";
import LoaderHome from "../../Loader/LoaderHome"
import axios from "axios";
import { Badge } from "react-bootstrap";
import ModalContentReusable from "../../Global/ModalContent";
// generate s

export default function ModalPriceTreatment(props) {
    console.log(props)
    const token = localStorage.getItem("token");
    const [loading, setLoading] = useState(false);
    // Untuk Close Proops Data
    const [propsData, setProopsData] = useState()
    const [getDataCode, setGetCode] = useState()
    const [page, setPage] = useState(1);
    const [limit] = useState(10);
    const [pages, setPages] = useState();
    const [ascending] = useState(0);
    const [getProvince, setGetProvince] = useState([])
    const [getRegency, setGetRegency] = useState([])
    const [getDistrict, setGetDistrict] = useState([])
    const [getSubDistrict, setGetSubDistrict] = useState([])
    const [provinceLoaded, setProvinceLoaded] = useState(false);
    const [cityLoaded, setCityLoaded] = useState(false);
    const [districtLoaded, setDistrictLoaded] = useState(false);
    const [getDataCoba, setGetDataCoba] = useState([])
    const [getDataTokenSatuSehat, setGetDataTokenSatuSehat] = useState([]);
    const [modalShow, setModalShow] = useState(false);
    const [errors, setErrors] = useState({});
    return (
        <ModalContentReusable
            isOpen={props.show}
            isClose={props.onHide}
            //   handleSubmit={handleSubmit.mutate}
            //   handleChange={handleChange}
            size="xl"
            title="Harga Treatment"
        >
            <table className="table table-bordered table-hover">
                <thead>
                    <tr>
                        <th>No.</th>
                        <th>Treatment</th>
                        <th>Qty</th>
                        <th>Harga</th>
                        <th>Diskon</th>
                        <th>Total Pembayaran</th>
                        <th>Status</th>
                    </tr>
                </thead>
                <tbody>
                    {props?.user.medical_invoice_data.medical_treatment_invoices.map((invoice, index) => {
                        const qty = invoice.qty ?? 0;
                        const effectiveQty = qty === 32 ? 1 : qty;
                        const price = invoice.price ?? 0;
                        const discount = invoice.discount ?? 0;

                        const totalPrice = price * effectiveQty;
                        const totalDiscount = discount * effectiveQty;
                        const priceAfterDiscount = totalPrice - totalDiscount;

                        return (
                            <tr key={index}>
                                <td>{(page - 1) * 10 + index + 1}</td>
                                <td>{invoice.medical_record.treatment_plan_detail.treatment_data.name_icd9}</td>
                                <td>{effectiveQty}</td>
                                <td>Rp {totalPrice.toLocaleString("id-ID")}</td>
                                <td>Rp {totalDiscount.toLocaleString("id-ID")}</td>
                                <td>Rp {priceAfterDiscount.toLocaleString("id-ID")}</td>
                                <td>
                                    {props?.user?.paid_status === 1 ? (
                                        <button className="btn btn-success btn-sm w-100 fw-bold" disabled>
                                            Lunas
                                        </button>
                                    ) : (
                                        <button className="btn btn-danger btn-sm w-100 fw-bold" disabled>
                                            Belum Lunas
                                        </button>
                                    )}
                                </td>
                            </tr>
                        );
                    })}

                    {(() => {
                        const paymentName = props?.user?.payment_data?.name ?? "";
                        const extraFee = paymentName === "Asuransi" ? 100000 : 75000;

                        const grandTotal = props?.user.medical_invoice_data.medical_treatment_invoices.reduce((sum, invoice) => {
                            const qty = invoice.qty ?? 0;
                            const effectiveQty = qty === 32 ? 1 : qty;
                            const price = invoice.price ?? 0;
                            const discount = invoice.discount ?? 0;

                            const totalPrice = price * effectiveQty;
                            const totalDiscount = discount * effectiveQty;
                            const priceAfterDiscount = totalPrice - totalDiscount;

                            return sum + priceAfterDiscount;
                        }, 0) + extraFee;

                        return (
                            <tr className="fw-bold">
                                <td colSpan="5" className="text-end">Pembayaran</td>
                                <td>{paymentName}</td>
                                <td>Rp {grandTotal.toLocaleString("id-ID")}</td>
                            </tr>
                        );
                    })()}
                </tbody>
            </table>

        </ModalContentReusable>
    );
}


